<mat-progress-bar
  data-at-progress-bar
  id="progress-bar"
  *ngIf="isLoading"
  mode="determinate"
  [value]="value"
  class="get-loader"
></mat-progress-bar>
